// Kreux Matrix — Agent Team Network (rectangle teams, no visible frame)
// ----------------------------------------------------------------
// Four teams of FOUR agents each, arranged at the corners of a
// rectangle. The team's shape is only IMPLIED by the 4 corner
// positions — no outline is drawn anywhere.
//
// Cyclic relay:  A → B → D → C → A → ...
//
// All coordinates are normalised to [0..1] of the hero background.

const TEAMS = [
  // Team A — top-left rectangle (pushed above the eyebrow)
  {
    label: "A",
    nodes: [
      [0.07, 0.13], // 0  TL
      [0.07, 0.28], // 1  BL
      [0.30, 0.28], // 2  BR
      [0.30, 0.13], // 3  TR — LEAD (faces Team B → right)
    ],
  },
  // Team B — top-right rectangle
  {
    label: "B",
    nodes: [
      [0.93, 0.13], // 0  TR
      [0.93, 0.28], // 1  BR
      [0.70, 0.28], // 2  BL
      [0.70, 0.13], // 3  TL — LEAD (faces Team D → down)
    ],
  },
  // Team D — bottom-right rectangle (pushed below the CTA)
  {
    label: "D",
    nodes: [
      [0.93, 0.92], // 0  BR
      [0.93, 0.80], // 1  TR
      [0.70, 0.92], // 2  BL
      [0.70, 0.80], // 3  TL — LEAD (faces Team C → left)
    ],
  },
  // Team C — bottom-left rectangle
  {
    label: "C",
    nodes: [
      [0.07, 0.92], // 0  BL
      [0.07, 0.80], // 1  TL
      [0.30, 0.92], // 2  BR
      [0.30, 0.80], // 3  TR — LEAD (faces Team A → up)
    ],
  },
];

const TEAM_FLOW_ORDER = [0, 1, 2, 3];

export const NODE_LAYOUT = [];
export const NODE_META = [];

TEAMS.forEach((team, ti) => {
  team.nodes.forEach((pos, ni) => {
    NODE_LAYOUT.push(pos);
    NODE_META.push({
      team: ti,
      teamLabel: team.label,
      isLead: ni === 3,
    });
  });
});

// Centroid + half-extents per team (only used by the label layer)
export const TEAM_BOUNDS = TEAMS.map((team, ti) => {
  const xs = team.nodes.map((n) => n[0]);
  const ys = team.nodes.map((n) => n[1]);
  const minX = Math.min(...xs);
  const maxX = Math.max(...xs);
  const minY = Math.min(...ys);
  const maxY = Math.max(...ys);
  return {
    teamIndex: ti,
    label: team.label,
    cx: (minX + maxX) / 2,
    cy: (minY + maxY) / 2,
    halfW: (maxX - minX) / 2,
    halfH: (maxY - minY) / 2,
  };
});

// --- Intra-team adjacency -----------------------------------------
// 4 nodes per team. The LEAD (index 3) connects to all 3 others, and
// the remaining three form a small chain so packets can wander.
const INTRA_PATTERN = [
  [0, 3], [1, 3], [2, 3], // lead spokes
  [0, 1], [1, 2],         // outer chain
];

export const ADJACENCY = NODE_LAYOUT.map(() => []);

TEAMS.forEach((_, ti) => {
  const base = ti * 4;
  INTRA_PATTERN.forEach(([a, b]) => {
    ADJACENCY[base + a].push(base + b);
    ADJACENCY[base + b].push(base + a);
  });
});

// --- Inter-team handoff (CYCLIC) ---------------------------------
export const LEAD_NEXT = {};
for (let i = 0; i < TEAM_FLOW_ORDER.length; i++) {
  const fromTeam = TEAM_FLOW_ORDER[i];
  const toTeam = TEAM_FLOW_ORDER[(i + 1) % TEAM_FLOW_ORDER.length];
  LEAD_NEXT[fromTeam * 4 + 3] = toTeam * 4 + 3;
}

export const TEAM_INDICES = TEAMS.map((_, ti) =>
  [0, 1, 2, 3].map((n) => ti * 4 + n)
);
